/**
 * Hybrid Demo Controller - AngularJS Controller
 *
 * This controller demonstrates an AngularJS view that contains:
 * 1. AngularJS native content
 * 2. Angular 18 downgraded components (ng-alert)
 * 3. Lit web components (example-card)
 *
 * This is the recommended pattern for gradually migrating views:
 * - Keep the AngularJS shell/routing
 * - Add Angular components as needed
 * - Use Lit for framework-agnostic shared components
 */
import angular from 'angular';

class HybridDemoController {
  static $inject = ['$window'];

  framework = 'AngularJS 1.8';
  counter = 0;

  constructor(private $window: angular.IWindowService) {}

  increment(): void {
    this.counter++;
  }

  goBack(): void {
    this.$window.history.back();
  }
}

export const HybridDemoControllerModule = angular
  .module('acme.view.application.hybridDemo', [])
  .controller('HybridDemoController', HybridDemoController).name;

